<template>
   <div class="container-fluid p-4 client-dashboard">

      <div class="page-hero">
        <div>
          <p class="eyebrow mb-1">Client dashboard</p>
          <h4 class="welcome-title">Welcome back, {{ username }}!</h4>
          <p class="hero-copy mb-0">Track your tokens, subscriptions, bookings, and account settings from one clean workspace.</p>
        </div>
      </div>

      <div class="row g-3">
        <!-- Wallet Balance -->
        <div class="col-md-4">
          <div class="card dashboard-card wallet-card">
            <div class="card-body text-center p-4">
              <!-- Icon Circle -->
              <div class="wallet-icon d-inline-flex align-items-center justify-content-center mb-3" 
                  style="width:60px; height:60px; border-radius:50%; background:rgba(25,135,84,0.1);">
                  <i class="fa fa-wallet text-success fa-lg"></i>
              </div>
              <!-- Balance Label -->
              <h6 class="wallet-label mb-1">Token Balance</h6>
              <!-- Balance -->
              <h2 class="wallet-value">{{ formatToken(walletBalance) }}<span class="token-label">{{ token_label }}</span> <button class="conversion-toggle" @click="convertRate" style="cursor: pointer;"><i class="fa fa-exchange-alt"></i></button> <span v-if="showNaria" class="text-muted">&#8358;{{ formatAmount(nairaBalance) }}</span></h2>

              <!-- Fund Wallet Button -->
              <button class="btn btn-success btn-sm px-4 py-2 fw-semibold shadow-sm rounded-pill" 
              data-bs-toggle="modal" data-bs-target="#fundWalletModal">
                <i class="fa fa-plus-circle me-2"></i>Buy Token
              </button>
            </div>
          </div>
        </div>

        <!-- Subscriptions -->
        <div class="col-md-8">
          <div class="card dashboard-card" style="height: 220px; overflow-y: auto;">
            <!-- Header -->
            <div class="card-header">
              <h6 class="section-title mb-0"><i class="fa fa-id-card"></i> My Subscriptions</h6>
            </div>

            <!-- Body -->
            <div class="card-body p-0 table-shell">
              <div class="table-responsive">
                <table class="table table-striped table-hover align-middle mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>#</th>
                      <th>Model</th>
                      <th>Tier</th>
                      <th>Duration</th>
                      <th>Token</th>
                      <th>Expires</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(sub, index) in subscriptionsList" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td><span class="text-dark">{{ sub.model_username }}</span></td>
                      <td><span class="text-dark">{{ sub.tier_name }}</span></td>
                      <td><span class="text-dark">{{ sub.duration }} days</span></td>
                      <td><span class="text-dark">{{ formatPrice(sub.dayruns_token) }}{{ token_label }}</span></td>
                      <td><span class="text-dark">{{ new Date(sub.expires_at).toDateString() }}</span></td>
                      <td>
                        <span
                          class="badge px-3 py-2 rounded-pill"
                          :class="{
                            'bg-success': sub.status === 'active',
                            'bg-danger': sub.status === 'expired'
                          }"
                        >
                          {{ sub.status }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Empty State -->
              <div v-if="subscriptionsList.length === 0" class="empty-state">
                No active subscriptions.
              </div>
            </div>
          </div>
        </div>
      </div>

       <!-- Booking list -->
       <div class="card section-card mt-3">
        <div class="card-header">
          <h6 class="section-title"><i class="fa fa-home"></i> My Bookings</h6>
        </div>
        <div class="card-body shadow table-responsive table-shell">
          <table class="table table-striped table-hover align-middle mb-0">
            <thead>
              <tr>
                <th>Model</th>
                <th>Token</th>
                <th>DateTime</th>
                <th>Time</th>
                <th>Duration</th>
                <th>Message</th>
                <th>Booking Status</th>
                <th>Fee Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in bookingList" :key="index">
                <td>{{ item.name }}</td>
                <td>{{ formatPrice(item.dayruns_token) }}{{ token_label }}</td>
                <td>{{ new Date(item.booked_at).toDateString() }}</td>
                <td>{{ item.time }}</td>
                <td>{{ item.duration }}</td>
                <td>{{ item.message }}</td>
                <td>
                  <span
                      class="badge"
                      :class="{
                        'badge-success': item.status === 'accepted' || item.status === 'completed',
                        'badge-primary': item.status === 'declined',
                        'badge-danger': item.status === 'cancelled' || item.status === 'expired',
                        'badge-warning': item.status === 'pending',
                        'badge-secondary': item.status === 'transfered'
                      }"
                    >
                    {{ item.status }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge"
                    :class="{
                      'badge-success': item.fees_status === 'approved',
                      'badge-warning': item.fees_status === 'pending'
                    }"
                  >
                    {{ item.fees_status }}
                  </span>
                </td>
                <td>
                  <button v-if="item.status === 'pending'" class="action-button" @click="cancel_booking(item.id)"><i class="fa fa-times"></i>Cancel</button>
                  <span v-if="item.fees_status === 'pending'">
                    <button class="action-button primary-action" v-if="item.status === 'accepted'" @click="approve_fee(item.id)">Approve fee</button>
                  </span>
                  <button
                    v-if="item.status === 'accepted' || item.status === 'completed'"
                    class="action-button danger-action"
                    @click="openBookingDisputeModal(item)"
                  >
                    <i class="fa fa-exclamation-triangle"></i> Dispute
                  </button>
                 
                </td>
               
              </tr>
            </tbody>
          </table>
        </div>
         <!-- Empty State -->
      <div v-if="bookingList.length === 0" class="empty-state">
                No bookings available.
          </div>
      </div>

      <!-- Booking Dispute Modal -->
      <div class="modal fade" id="bookingDisputeModal" tabindex="-1" aria-hidden="true" ref="bookingDisputeModal">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-danger text-white">
              <h5 class="modal-title fw-bold">
                <i class="fa fa-exclamation-triangle me-2"></i> Report No-Show
              </h5>
              <button class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
              <p class="text-muted mb-2">
                Use this if the model refused to show up or the booking was not honored.
              </p>

              <div class="mb-3">
                <label class="form-label fw-semibold">Booking</label>
                <input type="text" class="form-control" :value="selectedBookingDispute.name || selectedBookingDispute.model_username || 'N/A'" readonly>
              </div>

              <div class="mb-3">
                <label class="form-label fw-semibold">Reason</label>
                <textarea
                  class="form-control"
                  rows="4"
                  v-model="bookingDisputeReason"
                  placeholder="Tell us what happened"
                ></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button class="btn btn-danger" @click="submitBookingDispute">Submit Dispute</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Truth & Dare Requests -->
      <div class="card section-card mt-3">
        <div class="card-header">
          <h6 class="section-title"><i class="fa fa-comments"></i> Truth & Dare</h6>
        </div>
        <div class="card-body shadow table-responsive table-shell">
          <table class="table table-striped table-hover align-middle mb-0">
            <thead>
              <tr>
                <th>Model Name</th>
                <th>Request Type</th>
                <th>Description</th>
                <th>Token</th>
                <th>Status</th>
                <th>Deadline</th>
                <th>Proof uploaded</th>
                <th>Date uploaded</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in truthDareRequests" :key="index">
                <td>{{ item.name }}</td>
                <td>{{ item.request_type }}</td>
                <td>{{ item.request_details }}</td>
                <td>{{ item.dayruns_token }}{{ token_label }}</td>
                <td>
                  <span
                    class="badge"
                    :class="{
                      'badge-success': item.status === 'accepted' || item.status === 'completed',
                      'badge-primary': item.status === 'declined',
                      'badge-danger': item.status === 'cancelled' || item.status === 'expired',
                      'badge-warning': item.status === 'pending'
                    }"
                  >
                    {{ item.status }}
                  </span>
                </td>
                <td>{{ new Date(item.deadline).toLocaleString()}}</td>
                <td>
                  <span v-if="item.proof_media">
                    <a class="table-link" :href="item.proof_media">View proof</a>
                  </span>
                </td>
                <td>{{
                    item.proof_datetime
                      ? new Date(item.proof_datetime).toLocaleString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        })
                      : '-'
                  }}</td>
                <td>
                  <button style="border-radius: 40px; font-size: 10px;" v-if="item.status === 'pending'" class="btn btn-danger btn-sm me-2" @click="cancelTruthDare(item.id)">Cancel</button>
                  <button
                    style="border-radius: 40px; font-size: 10px;"
                    v-if="item.proof_media && item.status === 'accepted'"
                    class="btn btn-success btn-sm"
                    :disabled="releasingTruthDareId === item.id"
                    @click="releaseTruthDareFunds(item)"
                  >
                    <span v-if="releasingTruthDareId === item.id">Releasing...</span>
                    <span v-else>Release fund</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
         <!-- Empty State -->
      <div v-if="truthDareRequests.length === 0" class="empty-state">
                No record available.
          </div>
      </div>

      <!-- Dispute Tickets -->
      <div class="card section-card mt-3">
        <div class="card-header">
          <h6 class="section-title"><i class="fa fa-ticket-alt"></i> Dispute Tickets</h6>
        </div>
        <div class="card-body shadow table-responsive table-shell">
          <table class="table table-striped table-hover align-middle mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Ticket ID</th>
                <th>Request</th>
                <th>Username</th>
                <th>Description</th>
                <th>Type</th>
                <th>Status</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ticket, index) in disputeTickets" :key="ticket.id">
                <td>{{ index + 1 }}</td>
                <td>{{ ticket.ticket_id }}</td>
                <td><button @click="viewRequest(ticket.request_id, ticket.dispute_type)" class="btn btn-sm btn-outline-primary">View</button> </td>
                <td>{{ ticket.username }}</td>
                <td>{{ ticket.description }}</td>
                <td>
                  <span class="badge badge-info text-capitalize">
                    {{ ticket.dispute_type }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge"
                    :class="{
                      'badge-success': ticket.status === 'resolved',
                      'badge-primary': ticket.status === 'open',
                      'badge-danger': ticket.status === 'rejected',
                      'badge-warning': ticket.status === 'pending'
                    }"
                  >
                    {{ ticket.status }}
                  </span>
                </td>
                <td>{{ new Date(ticket.created_at).toLocaleString() }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      <div v-if="disputeTickets.length === 0" class="empty-state">
          No dispute tickets available.
        </div>
      </div>

      <!-- Request Details Modal -->
      <div class="modal fade" id="requestDetailsModal" tabindex="-1" aria-hidden="true" ref="requestDetailsModal">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content rounded-4 shadow-lg">
            <div class="modal-header bg-primary text-white rounded-top-4">
              <h5 class="modal-title fw-bold">
                <i class="fa fa-info-circle me-2"></i> Booking Details
              </h5>
              <button class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
              <div class="row g-3">

                <div class="col-md-6">
                   <div class="detail-pill">
                    <span class="detail-label">Model Name</span>
                    <span class="detail-value">{{ disputeTicketsDetails.name || 'N/A' }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="detail-pill">
                    <span class="detail-label">Status</span>
                    <span class="detail-value text-capitalize">{{ disputeTicketsDetails.status || 'N/A' }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="detail-pill">
                    <span class="detail-label">Fee Status</span>
                    <span class="detail-value text-capitalize">{{ disputeTicketsDetails.fees_status || 'N/A' }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="detail-pill">
                    <span class="detail-label">Booked At</span>
                    <span class="detail-value">{{ disputeTicketsDetails.booked_at ? new Date(disputeTicketsDetails.booked_at).toLocaleString() : 'N/A' }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="detail-pill">
                    <span class="detail-label">Time</span>
                    <span class="detail-value">{{ disputeTicketsDetails.time || 'N/A' }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="detail-pill">
                    <span class="detail-label">Duration</span>
                    <span class="detail-value">{{ disputeTicketsDetails.duration || 'N/A' }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="detail-pill">
                    <span class="detail-label">Booking Amount</span>
                    <span class="detail-value">{{ formatPrice(disputeTicketsDetails.booking_amount || 0) }}{{ token_label }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="detail-pill">
                    <span class="detail-label">Token</span>
                    <span class="detail-value">{{ formatPrice(disputeTicketsDetails.dayruns_token || 0) }}{{ token_label }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="detail-pill">
                    <span class="detail-label">Phone</span>
                    <span class="detail-value">{{ disputeTicketsDetails.phone || 'N/A' }}</span>
                  </div>
                </div>
                <div class="col-12">
                  <div class="detail-pill">
                    <span class="detail-label">Message</span>
                    <span class="detail-value">{{ disputeTicketsDetails.message || 'N/A' }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="detail-pill">
                    <span class="detail-label">Created At</span>
                    <span class="detail-value">{{ disputeTicketsDetails.created_at ? new Date(disputeTicketsDetails.created_at).toLocaleString() : 'N/A' }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="detail-pill">
                    <span class="detail-label">Updated At</span>
                    <span class="detail-value">{{ disputeTicketsDetails.updated_at ? new Date(disputeTicketsDetails.updated_at).toLocaleString() : 'N/A' }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-outline-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Profile Settings -->
      <div class="row settings-grid">
        <!-- Edit Profile -->
        <div class="col-md-6">
          <div class="card section-card settings-panel">
            <div class="card-header bg-white border-1">
              <h6 class="section-title"><i class="fa fa-user"></i> Edit Profile</h6>
              <button class="action-button" @click="edit_profile"><i class="fa fa-edit"></i></button>
            </div>
            <div class="card-body" v-if="isProfile">
              <form >
                <div class="mb-3">
                  <label class="form-label">Full name</label>
                  <input type="text"  class="form-control" v-model="fullname" required readonly />
                </div>
                <div class="mb-3">
                  <label class="form-label">Email</label>
                  <input type="email"  class="form-control" v-model="email" required readonly/>
                </div>
                <div class="mb-3">
                  <label class="form-label">Phone</label>
                  <input type="text"  class="form-control" v-model="phone" readonly />
                </div>
                <button class="btn btn-success px-4">Save Changes</button>
              </form>
            </div>
          </div>
        </div>

        <!-- Change Password -->
        <div class="col-md-6">
          <div class="card section-card settings-panel">
            <div class="card-header bg-white border-1">
              <h6 class="section-title"><i class="fa fa-lock"></i> Change Password</h6>
              <button class="action-button" @click="change_password"><i class="fa fa-edit"></i></button>
            </div>
            <div class="card-body" v-if="isPassword">
                <div class="mb-3">
                  <label class="form-label">Current Password</label>
                  <input type="password"  class="form-control" v-model="current_password" required />
                </div>
                <div class="mb-3">
                  <label class="form-label">New Password</label>
                  <input type="password"  class="form-control" v-model="password" required />
                </div>
                <div class="mb-3">
                  <label class="form-label">Confirm New Password</label>
                  <input type="password"  class="form-control" v-model="confirm_password" required />
                </div>
                <button class="btn btn-success px-4" @click="updatePassword">Update Password</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Purchase Token Modal -->
      <div class="modal fade" id="fundWalletModal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content rounded-4 shadow-lg">

            <!-- Header -->
            <div class="modal-header bg-primary text-white rounded-top-4">
              <h5 class="modal-title fw-bold">
                <i class="fa fa-coins me-2"></i> Buy Tokens
              </h5>
              <button class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>

            <!-- Body -->
            <div class="modal-body">

              <p class="text-muted mb-4">
                Transactions on this platform require tokens. Please select a token package below.
              </p>

              <!-- Token Cards -->
              <div class="row g-3">
                <div
                  class="col-4 col-md-3"
                  v-for="token in tokens"
                  :key="token.id"
                >
                  <div class="card border-0 shadow-sm h-80 text-center p-2 token-card">

                    <!-- Token Icon -->
                    <div class="mb-1">
                      <i class="fa fa-coins fa-lg text-warning"></i>
                    </div>

                    <!-- Token Amount -->
                    <h6 class="fw-bold small mb-1 config">
                      {{ token.number_of_token }}{{ token_label }}
                    </h6>

                    <!-- Price -->
                    <h6 class="text-primary fw-bold mb-2 config">
                      &#8358;{{ formatNumber(token.price) }}
                    </h6>

                    <!-- Buy Button -->
                    <button
                      class="btn btn-success btn-sm w-100"
                      @click="buyToken(token)"
                    >
                      Buy
                    </button>

                  </div>
                </div>
              </div>

              <!-- Info -->
              <div class="alert alert-info d-flex align-items-center mt-4">
                <i class="fa fa-info-circle me-2"></i>
                Once payment is successful, your wallet will be credited within 2 minutes.
              </div>

            </div>

            <!-- Footer -->
            <div class="modal-footer">
              <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
                Close
              </button>
            </div>

          </div>
        </div>
      </div>

      <!-- Payment Link Generation Modal -->
      <div
        class="modal fade"
        id="paymentLinkModal"
        tabindex="-1"
        aria-hidden="true"
        ref="paymentLinkModal"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content rounded-4 shadow-lg border-0">
            <div class="modal-body text-center p-5">
              <div class="spinner-border text-primary mb-3" role="status" aria-hidden="true"></div>
              <h5 class="fw-bold mb-2">Generating payment link</h5>
              <p class="text-muted mb-0">
                Please wait while we prepare your payment window.
              </p>
            </div>
          </div>
        </div>
      </div>
  </div>

</template>
  
<script>
import swal from 'sweetalert2';
import * as bootstrap from 'bootstrap'
//import PaystackPop from '@paystack/inline-js';

export default {

    components: {    
    },
    
    data() {
    return {
        pageLoader: false,
        image_path: '',
        splashScreen: false,
        selectedImage: null,
        showImageDialog: false,
        profile: true,
        btn_success: false,
        btn_success2: false,
        previewLoading: false,
        previewImage:'',
        photo_desc: '',
        is_picture_premium: '',
        previewVideo:'',
        myprofile: '',
        age: '',

        fullname: '',
        email:'',
        phone: '',
        current_password: '',
        password: '',
        confirm_password: '',

        userid: '',
        client_data: '',

        day: '',
        month: '',
        year: '',
        gender: '',
        location: '',
        state: '',
        from:'',
        to:'',
        travel_date: '',
        aboutyou: '',
        occupation: '',
        religion: '',
        sexuality: '',
        relationship_goal: '',
        loading: false,
        loading2: false,
        tloading: false,
        cloading: false,
        rloading: false,
        vloading: false,

        personality: [],
        interests: [],
        turnOns: [],
        turnOffs: [],
        smokes: '',
        drinks: '',
        tattoosOrPiercings: '',
        groupBooking: '',
        videoChatAvailable: '',
        transportPreference: [],
        build: '',
        bustSize: '',
        ethnicity: '',
        education: '',
        occupations: '',
        weight: '',
        height: '',
        rates: [],
        countLikes: 0,
        countFollowers: 0,
        listFollowers: [],
        profilePictureFile: '',
        profileVideoFile: '',
        escort_video: [],
        services: [],
        video_description: '',
        is_video_premium: '',
        logoutSplash: false,
        logoutMessage: "",
        planId:'',
        features: '',
        monetizedServices: [],
        selectedRequest: {},
        proofDeadline: '',
        proofFile: null,
        selectedBookingDispute: {},
        bookingDisputeReason: '',
        releasingTruthDareId: null,
        editSubs: false,
        subscriptionId: '',
        isEscort: '',
        walletBalance: 0,
        nairaBalance: 0,
        showNaria: false,
        subscriptionsList: [],

        truthDareRequests: [],
        disputeTickets: [],
        disputeTicketsDetails: [],
        username: '',
        user_id: '',
        bookingList: [],
        isProfile: false,
        isPassword: false,
        bank_name: '',
        account_name: '',
        account_number: '',
        apikey: '',
        fund_amount: '',
        tokens: [],
        selected_tokens: null,
        token_label: process.env.VUE_APP_TOKEN_LABEL,
        paymentLinkModalInstance: null,
        timer: null,
        reference: null,

        };
    },

async beforeMount(){
   
    this.userid = this.$route.params.clientid;
    this.username = this.$route.params.username;
    this.user_id = localStorage.getItem("userid"); 
},

async mounted(){
  this.reference = Date.now();
  this.listMyProfile(this.userid)
  this.fetchAllTokens()
  await this.getConfigData()
  this.reverseBooking()
  this.reverseTruthDare()
  
},

beforeDestroy() {
  if (this.timer) {
      clearInterval(this.timer);
  }
},
    
methods: {
    startPolling() {
        this.timer = setInterval(async () => {
            try {
                 const res = await this.$http.post("/payment-status", {
                      reference: this.reference
                  });

                if (res.data.status === "00") {
                    clearInterval(this.timer);

                    window.location.reload();
                }
            } catch (err) {
                console.error(err);
            }
        }, 3000);
    },
   async reverseBooking() {
        try{
      
            const response = await this.$http.get(`/reverse-expired-booking`,{} )
            if(response.data.success){
              
                return;
            }
    
        }catch (err) {
            console.log(err);
        }
    },

    async reverseTruthDare() {
        try{
      
            const response = await this.$http.get(`/reverse-expired-truthdare`,{} )
            if(response.data.success){
              
                return;
            }
    
        }catch (err) {
            console.log(err);
        }
    },

    async cancelTruthDare(id) {
        try{
        
            // Prompt user before deletion
            const confirmDelete = confirm("Are you sure you want to cancel?");
            if (!confirmDelete) {
            return; // Exit if user cancels
            }
            const response = await this.$http.get(`/cancel-truthdare/${id}`,{} )
            if(response.data.success){
                // Set splash message
                this.logoutMessage = response.data.message || `Request canceled!`;
                this.logoutSplash = true;
                // Wait before redirecting
                setTimeout(() => {
                window.location.reload()
                this.logoutSplash = false;
                }, 2500); // splash visible for 2.5 seconds
                return;
            }
    
        }catch (err) {
            console.log(err);
        }
    },

    formatToken(value) {
      const num = Number(value);

      if (!Number.isFinite(num)) {
        return value ?? '0';
      }

      // Keep small values readable, show one decimal for thousands, and cap million-plus at 1m.
      if (num >= 1000000) {
        return '1m';
      }

      if (num >= 1000) {
        const abbreviated = (num / 1000).toFixed(1).replace(/\.0$/, '');
        return `${abbreviated}k`;
      }

      return new Intl.NumberFormat('en-US').format(num);
    },
    convertRate(){
      if(!this.showNaria){
        this.showNaria = true
      }else{
        this.showNaria = false
      }
    },
    fundWallet() {
      alert("Redirecting to wallet funding page...");
    },
    edit_profile(){
      if(!this.isProfile){
        this.isProfile = true
      }else{
        this.isProfile = false
      }
    },
    change_password(){
      if(!this.isPassword){
        this.isPassword = true
      }else{
        this.isPassword = false
      }
    },
    async fetchAllTokens(){
        try{
        const response = await this.$http.get(`/fetch-tokens`,{} )
        this.tokens = response.data.data;
    
        }catch (err) {
            console.log(err);
        }
    },
    formatNumber(value) {
      return new Intl.NumberFormat().format(value);
    },
    buyToken(token) {
      this.selected_tokens = token.number_of_token;
      this.fund_amount = token.price;

      // Call payment function
      this.makePayment();
    },
    async getTruthDareRequests(client_id){
        try{
        const response = await this.$http.get(`/fetch-client-truthdare/${client_id}`,{} )
        this.truthDareRequests = response.data.data;
    
        }catch (err) {
            console.log(err);
        }
    },

    async getDisputeTickets(client_id){
        try{
        const response = await this.$http.get(`/fetch-dispute-tickets/${client_id}`,{} )
        this.disputeTickets = response.data.data;
    
        }catch (err) {
            console.log(err);
        }
    },

    async viewRequest(request_id, request_type) {
    try{
            const response = await this.$http.get(`/fetch-request-details/${request_id}/${request_type}`,{} )
            const details = Array.isArray(response.data.data)
                ? response.data.data[0]
                : response.data.data;

            this.disputeTicketsDetails = details || {};

            const modal = new bootstrap.Modal(this.$refs.requestDetailsModal);
            modal.show();
    
        }catch (err) {
            console.log(err);
    }
    },

    async getBookings(client_id){
        try{
        const response = await this.$http.get(`/fetch-client-booking/${client_id}`,{} )
        this.bookingList = response.data.data;
    
        }catch (err) {
            console.log(err);
        }
    },

    async cancel_booking(record_id) {
      try {
        // Confirmation prompt
        const confirmed = confirm("Are you sure you want to cancel this booking?");
        if (!confirmed) return; // Stop if user cancels

        const response = await this.$http.get(`/cancel-client-booking/${record_id}`, {});

        if (response.data.success) {
          alert("Booking cancelled successfully!");
          // cancel record locally
          //this.bookingList = this.bookingList.filter(item => item.id !== record_id);

        } else {
          alert("Failed to cancelled booking.");
        }
      } catch (err) {
        console.log(err);
        alert("An error occurred while deleting.");
      }
    },

    async approve_fee(transactionId){
      try {
      // Confirmation prompt
      const confirmed = confirm("Are you sure you want to approve this model fee?");
        if (!confirmed) return; // Stop if user cancels

        const response = await this.$http.get(`/approve-model-fee/${transactionId}`, {});

        if (response.data.success) {
          alert("Fees approved successfully!");
          window.location.reload()
          // remove the deleted record locally
          //this.bookingList = this.bookingList.filter(item => item.id !== transactionId);

        } else {
          alert("Failed to approve fee.");
        }
      } catch (err) {
        console.log(err);
        alert("An error occurred while approving fee.");
      }
    },

    async releaseTruthDareFunds(item) {
      try {
        const confirmed = confirm("Are you sure you want to release funds for this request?");
        if (!confirmed) return;

        this.releasingTruthDareId = item.id;

        const response = await this.$http.post("/transfer-truthdare-fee", {
          amount: item.dayruns_token,
          client_id: this.client_id,
          payment_reference: Date.now(),
          truthdare_id: item.id,
          model_id: item.model_id
        });

        if (response.data.success) {
          alert("Funds released successfully!");
          item.status = "completed";
          window.location.reload();
        } else {
          alert(response.data.message || "Failed to release funds.");
        }
      } catch (err) {
        console.log(err);
        alert(err.response ? err.response.data.message : "An error occurred while releasing funds.");
      } finally {
        this.releasingTruthDareId = null;
      }
    },

    formatDate(date) {
        return date ? new Date(date).toLocaleString() : 'N/A';
    },
    openProofModal(request) {
        this.selectedRequest = request;
        this.proofDeadline = '';
        this.proofFile = null;

        let modal = new bootstrap.Modal(this.$refs.proofModal);
        modal.show();
    },

    openBookingDisputeModal(booking) {
        this.selectedBookingDispute = booking;
        this.bookingDisputeReason = '';

        const modal = new bootstrap.Modal(this.$refs.bookingDisputeModal);
        modal.show();
    },

    handleProofUpload(event) {
        this.proofFile = event.target.files[0];
    },

    async submitBookingDispute() {
      try {
        if (!this.bookingDisputeReason || !this.bookingDisputeReason.trim()) {
          alert("Please enter a reason for the dispute.");
          return;
        }

        const confirmed = confirm("Are you sure you want to submit this booking dispute?");
        if (!confirmed) return;

        const response = await this.$http.post('/dispute-request', {
          username: this.username,
          user_id: this.userid,
          request_id: this.selectedBookingDispute.id,
          description: this.bookingDisputeReason.trim(),
          dispute_type: 'booking',
        });

        if (response.data.success) {
          alert(response.data.message || 'Dispute submitted successfully!');
          const modalEl = this.$refs.bookingDisputeModal;
          const modalInstance = bootstrap.Modal.getInstance(modalEl);
          if (modalInstance) modalInstance.hide();
          window.location.reload();
        } else {
          alert(response.data.message || 'Failed to submit dispute.');
        }
      } catch (err) {
        console.error('Booking dispute error:', err);
        alert(err.response?.data?.message || 'Dispute submission failed. Please try again.');
      }
    },

    maskPhoneNumber(phone) {
        if (!phone) return '';
        return phone.slice(0, 4) + '*'.repeat(phone.length - 4);
    },
    generateYears() {
      const start = 1940;
      const end = new Date().getFullYear();
      for (let i = start; i <= end; i++) {
        this.yearsList.push(i);
      }
    },

    formatPrice(value) {
      return new Intl.NumberFormat('en-NG', {
      minimumFractionDigits: 0
    }).format(value);
    },

    async listMySubscription(clientId){
        try{
            const response = await this.$http.get(`/get-client-subscriptions/${clientId}`,{} )
            this.subscriptionsList = response.data.data;
        }catch (err) {
            console.log(err);
        }
    },

    async updatePassword() {
    try {

       const response = await this.$http.post('/change-password', {
        userid: this.userid,
        email: this.email,
        current_password: this.current_password,
        password: this.password,
        confirm_password: this.confirm_password
       })

        if (response.data.success) {
            swal.fire({
                icon: "success",
                title: "Success",
                width:450,
                height:5,
                text: response.data.message,
            });
            return;
        }
       
        this.current_password = "",
        this.password = "",
        this.confirm_password = ""

        window.location.reload();
    
        } catch (err) { 

            alert(err.response ? err.response.data.message : err.message)
        }

    },

    async getWalletbalance(userId) {
    try {

       const response = await this.$http.get(`/fetch-wallets-byuser/${userId}`, {})
      
        if (response.data.success) {
          this.walletBalance = response.data.data
          this.nairaBalance = response.data.naira
        }

        } catch (err) { 
          console.log(err.response.data.message)
            alert(err.response ? err.response.data.message : err.message)
        }
    },

    async listMyProfile(userid){
         try{
            this.pageLoader = true
            const response = await this.$http.get(`/list-guest-profile/${userid}` )
            this.client_data = response.data.data;
            this.fullname = this.client_data.fullname
            this.email = this.client_data.email_address
            this.phone = this.client_data.phone

            await this.listMySubscription(userid)
            await this.getTruthDareRequests(userid)
            await this.getDisputeTickets(userid)
            await this.getBookings(userid)

            if (this.user_id) {
              await this.getWalletbalance(userid)
            }
            
            this.pageLoader = false
        
            }catch (err) {
                console.log(err);
            }
    },

    async editProfile(userid){
        this.$router.push("/update-profile/"+userid +'/'+this.client_data.username)
    },
    async getStates() {
    try{
        const response = await this.$http.get('/state/fetch', {
          headers: { 
                "x-api-key": `${process.env.VUE_APP_API_KEY}`,
                'Content-Type': 'application/json' 
               },
        })

        response.data.states.forEach((el) => {
        this.options.push({
          value: el.state,
          text: el.state,
        });

      });
               
        }catch (err) {
            console.log(err);
        }
    },
    async remove(filepath) {
        let conf = confirm("           Are you sure about this?")
        if(conf == true) {
            this.splashScreen = true;
            this.response = await this.$http.post('/remove-gallery', {
                filepath: filepath
            });
            this.splashScreen = false;

            if (!this.response.data.success) {
                // Set splash message
                this.logoutMessage = this.response.data.message || "Removed not successful!";
                this.logoutSplash = true;
                // Wait before redirecting
                setTimeout(() => {
                this.logoutSplash = false;
                window.location.reload(); 
                }, 2500); // splash visible for 2.5 seconds
                this.listEscortProfile(this.userid)
                return;
            }else{

                this.logoutMessage = this.response.data.message || "Removed successfully!";
                this.logoutSplash = true;
                // Wait before redirecting
                setTimeout(() => {
                this.logoutSplash = false;
                window.location.reload(); 
                }, 2500); // splash visible for 2.5 seconds
                this.listEscortProfile(this.userid)
               
                return;
        }
    }
    },

    async removeVideo(filepath) {
        let conf = confirm("           Are you sure about this?")
        if(conf == true) {
            this.splashScreen = true;
            this.response = await this.$http.post('/remove-videos', {
                filepath: filepath
            });
            this.splashScreen = false;

            if (!this.response.data.success) {
                swal.fire({
                    icon: 'error',
                    width:350,
                    height:3,
                    title: this.response.data.message,
                });
                this.listEscortProfile(this.userid)
                return;
            }else{

                   // Set splash message
                this.logoutMessage = this.response.data.message || "Removed successfully!";
                this.logoutSplash = true;
                // Wait before redirecting
                setTimeout(() => {
                this.logoutSplash = false;
                window.location.reload(); 
                }, 2500); // splash visible for 2.5 seconds
                this.listEscortProfile(this.userid)
               
                return;
        }
    }
    },

    async save_tour(){
        try {

            this.tloading = true;

            // Send request
            const response = await this.$http.post('/create-tour', {
                escortid: this.escortid,
                from: this.from,
                to: this.to,
                travel_date: this.travel_date,
            });

            this.tloading = false;

            if (response.data.success) {
                this.logoutMessage = response.data.message || "Successful!";
                this.logoutSplash = true;
                // Wait before redirecting
                setTimeout(() => {
                this.logoutSplash = false;
                  // Hide the modal
                  document.getElementById("ontour").style.display = "none";
                }, 2500); // splash visible for 2.5 seconds
                  

            } else {
                swal.fire({
                    icon: 'warning',
                    width: 450,
                    text: response.data.message,
                });
            }
            } catch (err) {
                console.error(err);
                this.loading = false;
                swal.fire({
                icon: 'error',
                title: 'Server Error',
                text: err.response ? err.response.data.message : err.message,
            });
            }
    },

    async listEscortTour(escortid){
         try{

        const response = await this.$http.post('/list-escort-tours',{ escortid: escortid} )
        this.escort_tour = response.data.data;
    
        }catch (err) {
            console.log(err);
        }
    },

    async fetch_preferences() {
    try {

        const response = await this.$http.get(`/get-escort-preferences/${this.userid}`);

        if (response.data.success && response.data.data) {
        const prefs = response.data.data[0];

        this.personality = prefs.personality ? prefs.personality.split(',') : [];
        this.interests = prefs.interests ? prefs.interests.split(',') : [];
        this.turnOns = prefs.turn_ons ? prefs.turn_ons.split(',') : [];
        this.turnOffs = prefs.turn_offs ? prefs.turn_offs.split(',') : [];

        this.smokes = prefs.smokes || '';
        this.drinks = prefs.drinks || '';
        this.tattoosOrPiercings = prefs.tattoos_or_piercings || '';
        this.groupBooking = prefs.group_booking || '';
        this.videoChatAvailable = prefs.video_chat_available || '';
        this.transportPreference = prefs.transport_fare || '';
        this.build = prefs.build,
        this.bustSize = prefs.bustSize,
        this.ethnicity = prefs.ethnicity,
        this.education= prefs.education,
        this.occupations= prefs.occupations,
        this.weight = prefs.weight,
        this.height=prefs.height
        this.services = prefs.services ? prefs.services.split(',') : [];
        }
    } catch (err) {
        console.error(err);
        // swal.fire({
        // icon: 'error',
        // title: 'Error loading preferences',
        // text: err.response ? err.response.data.message : err.message,
        // });
    }
    },

    async create_preferences() {
    try {

        this.tloading = true;

        const payload = {
            escort_id: this.escortid,
            personality: this.personality,               // array
            interests: this.interests,                   // array
            turnOns: this.turnOns,                       // array
            turnOffs: this.turnOffs,                     // array
            smokes: this.smokes,                         // 'Yes' or 'No'
            drinks: this.drinks,                         // 'Yes' or 'No'
            tattoosOrPiercings: this.tattoosOrPiercings, // 'None', 'Tattoos', 'Piercings', 'Both'
            groupBooking: this.groupBooking,             // 'Yes' or 'No'
            videoChatAvailable: this.videoChatAvailable,  // 'Yes' or 'No'
            transportPreference: this.transportPreference,               // array
            build: this.build,
            bustSize: this.bustSize,
            ethnicity: this.ethnicity,
            education: this.education,
            occupations: this.occupations,
            weight: this.weight,
            height: this.height,
            services: this.services
        };

        const response = await this.$http.post('/create-escort-preferences', payload);

        this.tloading = false;

        if (response.data.success) {
                this.logoutMessage = response.data.message || "Successful!";
                this.logoutSplash = true;
                // Wait before redirecting
                setTimeout(() => {
                this.logoutSplash = false;
                window.location.reload(); 
                }, 2500); // splash visible for 2.5 seconds
       
        } else {
        swal.fire({
            icon: 'warning',
            width: 450,
            text: response.data.message,
        });
        }

    } catch (err) {
        console.error(err);
        this.tloading = false;
        swal.fire({
        icon: 'error',
        title: 'Server Error',
        text: err.response ? err.response.data.message : err.message,
        });
      }
    },

    addRate() {
    this.rates.push({ duration: '', in_call_price: '', out_call_price: '' });
    },

    async removeRate(index) {
        const rate = this.rates[index];

        // Confirm the rate has been saved (has an ID)
        if (rate.rateid) {
            const confirmDelete = await swal.fire({
            icon: 'warning',
            title: 'Are you sure?',
            text: 'This will permanently delete the rate.',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            });

            if (confirmDelete.isConfirmed) {
            try {
                const response = await this.$http.delete(`/delete-escort-rate/${rate.rateid}`);

                if (response.data.success) {
                this.rates.splice(index, 1); // Remove from UI
                this.logoutMessage = response.data.message || "Successful!";
                this.logoutSplash = true;
                // Wait before redirecting
                setTimeout(() => {
                this.logoutSplash = false;
                }, 2500); // splash visible for 2.5 seconds
                } else {
                swal.fire({
                    icon: 'error',
                    text: response.data.message || 'Failed to delete rate.',
                });
                }
            } catch (err) {
                console.error(err);
                swal.fire({
                icon: 'error',
                title: 'Server Error',
                text: err.response ? err.response.data.message : err.message,
                });
            }
            }
        } else {
            // Not saved in DB yet — just remove locally
            this.rates.splice(index, 1);
        }
    },

    async fetchRates() {
        try {
        const res = await this.$http.get(`/get-escort-rates/${this.userid}`);
        if (res.data.success && res.data.data.length > 0) {
            this.rates = res.data.data;
        } else {
            this.rates = [{ duration: '', inCall: '', outCall: '' }];
        }
        } catch (err) {
        console.error('Failed to fetch rates', err);
        }
    },

    async saveRates() {
        try {
        this.rloading = true;
        const payload = {
            escort_id: this.escortid,
            rates: this.rates,
        };
        const res = await this.$http.post('/create-escort-rates', payload);
        this.rloading = false;

        if (res.data.success) {
            this.logoutMessage = res.data.message || "Successful!";
            this.logoutSplash = true;
            // Wait before redirecting
            setTimeout(() => {
            this.logoutSplash = false;
            window.location.reload(); 
            }, 2500); // splash visible for 2.5 seconds
        } 
        } catch (err) {
        this.loading = false;
        console.error(err);
        swal.fire({ icon: 'error', title: 'Error', text: err.message });
        }
    },

    async handleChat() { 
        this.$router.push(`/chat/${this.escort_info.user_id}/${this.client_data.username}`)
    },

    async getFollowers(userid) {
    try {

        const response = await this.$http.get(`/escort-followers/${userid}`, {});
        this.countFollowers = response.data.data.length;
        this.listFollowers = response.data.data;
      
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },

    async getLikes(userid) {
    try {

        const response = await this.$http.get(`/escort-likes/${userid}`, {});
        this.countLikes = response.data.data.length
        
      
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },

    formatAmount(value) {
      return new Intl.NumberFormat('en-NG', {
      
      minimumFractionDigits: 0
    }).format(value);
    },

    async getConfigData(){
      const response = await fetch('/config.json');
      const configData = await response.json();
      this.apikey = configData.apikey;
    },

    //   makePayment(){
    //     const paystack = new PaystackPop();

    //     paystack.newTransaction({
    //         key: this.apikey,
    //         email: this.email,
    //         amount: Number(this.fund_amount) * 100,

    //         onSuccess: (transaction) => { 
    //             // Payment complete! Reference: transaction.reference 
    //             this.pay(transaction.reference )
    //         },
    //         onCancel: () => {
    //             // user closed popup
    //         }
    //     });
    // },

    async makePayment(){
        try{
          const response = await this.$http.post('/create-order', {
            amount: Number(this.fund_amount),
            planCode: "FBX-EA048B52-266",
            product: "Service Payment",
            name: this.fullname,
            email: this.email,
            phone: this.phone
          });

        if (response.data.success) {
          const paymentLink = response.data.data.paymentLink;

          if (!paymentLink) {
            swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Payment link could not be generated.',
              width: 400
            });
            return;
          }

          this.openPaymentLinkModal();

          setTimeout(() => {
            this.closePaymentLinkModal();
            // window.open(paymentLink, "_blank");
            window.location.href = paymentLink;
          }, 1500);

          this.pay()
        
        return;
        } 
             
        }catch (err) {
          console.log(err);
          alert(err.response ? err.response.data.message : err.message)

      }
    },

    async pay() {
        try{
          await this.$http.post('/pay', {
            user_id: this.user_id,
            email: this.email,
            amount: this.fund_amount,
            token: this.selected_tokens,
            payment_reference: this.reference
          });

          this.startPolling();
             
        }catch (err) {
          console.log(err);
      }

    },

    openPaymentLinkModal() {
      if (!this.paymentLinkModalInstance) {
        this.paymentLinkModalInstance = new bootstrap.Modal(this.$refs.paymentLinkModal, {
          backdrop: 'static',
          keyboard: false
        });
      }

      this.paymentLinkModalInstance.show();
    },

    closePaymentLinkModal() {
      if (this.paymentLinkModalInstance) {
        this.paymentLinkModalInstance.hide();
      }
    },

}
}

</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans&family=Raleway&display=swap');

.client-dashboard.container-fluid {
  margin-top: 24px !important;
  padding: 1.25rem !important;
  background: linear-gradient(180deg, #f7f8fc 0%, #ffffff 100%);
  border: 1px solid rgba(211, 62, 116, 0.08);
  border-radius: 24px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
}

.client-dashboard .card {
  margin-top: 0 !important;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 20px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.page-hero {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, rgba(211, 62, 116, 0.12), rgba(10, 7, 15, 0.03));
  border: 1px solid rgba(211, 62, 116, 0.14);
  border-radius: 20px;
  margin-top: 80px;
}

.eyebrow {
  margin: 0;
  color: #D33E74;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.welcome-title {
  margin: 0;
  color: #111827 !important;
  font-family: 'DM Sans';
  font-size: 1.5rem;
  font-weight: 800;
  line-height: 1.2;
}

.hero-copy {
  margin-top: 0.35rem;
  max-width: 60ch;
  color: #667085;
  font-size: 0.95rem;
}

.client-dashboard .card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  background: #fff;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  margin: 0;
  color: #111827;
  font-family: 'DM Sans';
  font-size: 1rem;
  font-weight: 700;
}

.section-title i {
  color: #D33E74;
}

.wallet-card .card-body {
  padding: 1.5rem !important;
}

.wallet-icon {
  width: 72px;
  height: 72px;
  border-radius: 20px !important;
  background: linear-gradient(135deg, rgba(211, 62, 116, 0.14), rgba(211, 62, 116, 0.04)) !important;
  box-shadow: inset 0 0 0 1px rgba(211, 62, 116, 0.12);
}

.wallet-icon .text-success {
  color: #D33E74 !important;
}

.wallet-label {
  color: #667085;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.wallet-value {
  margin-bottom: 0.9rem;
  color: #111827;
  font-size: 1.55rem;
  font-weight: 800;
  line-height: 1.2;
}

.wallet-value .token-label {
  margin-left: 0.2rem;
  color: #667085;
  font-size: 0.92rem;
  font-weight: 600;
}

.conversion-toggle {
  padding: 0;
  border: 0;
  background: transparent;
  color: #D33E74;
}

.table-shell {
  padding: 0 !important;
}

.table-shell .table {
  margin-bottom: 0;
}

.table-shell thead th {
  color: #667085;
  background: #f8fafc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.table-shell tbody td {
  color: #1f2937;
  vertical-align: middle;
}

.table-shell .table > :not(caption) > * > * {
  padding: 0.9rem 0.95rem;
}

.empty-state {
  padding: 1rem;
  color: #667085;
  font-size: 0.92rem;
  text-align: center;
}

.table-link {
  color: #D33E74;
  font-weight: 600;
  text-decoration: none;
}

.table-link:hover {
  text-decoration: underline;
}

.action-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.45rem 0.7rem;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 999px;
  background: #fff;
  color: #475467;
  transition: 0.2s ease;
}

.action-button:hover {
  transform: translateY(-1px);
  border-color: rgba(211, 62, 116, 0.28);
  color: #D33E74;
}

.primary-action {
  border-color: #D33E74;
  background: #D33E74;
  color: #fff;
}

.primary-action:hover {
  color: #fff;
  background: #bf2f66;
}

.danger-action {
  border-color: rgba(220, 53, 69, 0.22);
  background: #fff5f6;
  color: #b42318;
}

.danger-action:hover {
  border-color: rgba(220, 53, 69, 0.42);
  background: #ffe8eb;
  color: #991b1b;
}

.detail-pill {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.9rem 1rem;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 14px;
  background: #fff;
  min-height: 100%;
}

.detail-label {
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #667085;
}

.detail-value {
  font-size: 0.92rem;
  font-weight: 700;
  color: #111827;
  word-break: break-word;
}

.settings-grid {
  gap: 1rem;
}

.settings-panel .card-body {
  background: linear-gradient(180deg, #fff 0%, #fbfbfd 100%);
}

.client-dashboard .badge {
  font-weight: 600;
  letter-spacing: 0.01em;
  border-radius: 999px;
}

.client-dashboard .badge.bg-success,
.client-dashboard .badge.badge-success {
  background: #16a34a !important;
  color: #fff !important;
}

.client-dashboard .badge.bg-danger,
.client-dashboard .badge.badge-danger {
  background: #dc2626 !important;
  color: #fff !important;
}

.client-dashboard .badge.bg-warning,
.client-dashboard .badge.badge-warning {
  background: #f59e0b !important;
  color: #111827 !important;
}

.client-dashboard .badge.badge-primary {
  background: rgba(211, 62, 116, 0.12) !important;
  color: #D33E74 !important;
}

.client-dashboard .badge.badge-secondary {
  background: #64748b !important;
  color: #fff !important;
}

@media (max-width: 768px) {
  .page-hero {
    flex-direction: column;
    align-items: flex-start;
  }

  .wallet-value {
    font-size: 1.3rem;
  }

  .client-dashboard.container-fluid {
    padding: 1rem !important;
  }

  .client-dashboard .card-header {
    padding: 0.9rem 1rem;
  }

  .table-shell .table > :not(caption) > * > * {
    padding: 0.8rem 0.75rem;
  }
}

.config{
 font-size: 12px !important;
}
.token-card {
  transition: 0.3s ease;
  border-radius: 12px;

  h6{
    font-size: 10px;
  }
}

.token-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
}
table thead tr th{ font-size: 12px}
table tbody tr td{ font-size: 11px}
.text-success{
    color: #0A070F !important;
    font-weight: 400 !important;
}
.card-header{
  display:  flex;
  flex-direction: row;
  justify-content: space-between;

  h6{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
  }
}
.welcome-title{
  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 650;
  font-size: 14px;
}
.btn-success{
    background: #D33E74 !important;
    border: 0;
}
.modal-header{
  background: #D33E74 !important;
}
.card {
  margin-top: 50px;
  border-radius: 12px;
}
.shadow {
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.logout-splash {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  font-family: 'Raleway';
  font-style: normal;
  background-color: #0A070F; /* green success */
  color: white;
  padding: 15px;
  text-align: center;
  font-weight: bold;
  z-index: 9999;
  box-shadow: 0 2px 5px rgba(0,0,0,0.3);
  transition: top 0.3s ease-in-out;
}
.loading-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: transparent;
  position: absolute;
  z-index: 10;
}

.image-upload-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
}
.account-switch{
    width: 120px;
}
.video-upload-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
}
.img-fluid{
    border-radius: 10px;
    width: 100%;
    aspect-ratio: 4 / 5;
    object-fit: cover;
    border-radius: 10px;
    transition: transform 0.3s ease-in-out; /* Optional for smooth effect */
  }
.likes-followers{
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;

    h4{
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 11px;
        color: #FFFFFF;
    }
}

.image-preview {
  width: 160px;
  height: 160px;
  background-color: #f0f0f0;
  background-size: cover;
  background-position: center;
  border: 2px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: border-color 0.3s ease;
}

.image-preview:hover {
  border-color: #D33E74;
}

.video-preview {
  width: 160px;
  height: 160px;
  background-color: #f0f0f0;
  background-size: cover;
  background-position: center;
  border: 2px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: border-color 0.3s ease;
}

.video-preview:hover {
  border-color: #D33E74;
}

.upload-placeholder {
  text-align: center;
  color: #888;
  font-size: 14px;
}

.video-placeholder {
  text-align: center;
  color: #888;
  font-size: 14px;
}

.file-hidden {
  display: none;
}

.video-hidden {
  display: none;
}

.upload-actions {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}
.photo_desc{
    border: solid 0px;
    border-radius: 5px;
    background: #fff;
    font-size: 14px;
    font-family: 'Raleway';
    font-style: normal;
}

.video-actions {
  margin-top: 10px;
}

.rates {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 600;
    margin: 20px 0;
}
@media screen and (max-width: 768px) {
    .model-category{
        text-align: center;
    }
    .form-switch{
        text-align: center;
    }
    .rate-row {
        display: flex;
        flex-direction: column;
    }
    .rate-inputs {
        display: flex;
        flex-direction: column;
    }
}
.label-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;
  display: block;
}
.rate-row {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}
.rate-inputs {
  display: flex;
  gap: 10px;
  flex: 1;
}
.input-textx {
  padding: 8px;
  width: 100%;
}
.btn-add, .btn-remove, .btn-user-login {
    margin-top: 10px;
    color: #D33E74;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
}

.label-title{
    font-family: 'Raleway';
    font-weight: bold;
    font-size: 14px;
    color: #fff;
    background: #0A070F;
    border-radius: 10px;
    padding: 0.3rem;
}

.checkbox-group {
  margin-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.checkbox-group label {
  font-size: 14px;
  color: #D33E74;
}
.btn-user-login {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 5px;
    background: #D33E74;
    border-radius: 50px;
    color: #fff;
    width: 150px;
    height: 40px;
}
.label {
  display: block;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 5px;
}

.bio-tab{
    margin-top: 20px;
}
.nav-link{
    color: #D33E74;
}
.nav-tabs{
  border-bottom: 0px solid #111112;
}
 .nav-tabs .nav-link {
    cursor: pointer;
    font-family: 'Raleway';
    font-style: normal;
    font-size: 13px;
 }

.nav-tabs .nav-link.active {
    background-color: #D33E74;
    color: white;
    border-radius: 0.25rem;
    font-family: 'Raleway';
    font-style: normal;
    font-size: 13px;
}

.loader{
    width:100%;
    height:300px;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:20px;
    margin-top:-300px
  }
  .mobile-line{
    display: flex;
    color: #767475;
    width: 90%;
}
  .dot{
    height:40px;
    width:40px;
    border-radius:50%;
  }

.tab-content{
    background: #111112 !important;
    color: #fff !important;
    width: 100%;
    div p {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
    }
}
  .dot:nth-child(1){
    background-color:red;
    animation: jump 0.6s 0.5s ease-in infinite
  }
  .dot:nth-child(2){
    background-color:blue;
    animation: jump 0.6s 0.7s ease-in infinite
  }
  .dot:nth-child(3){
    background-color:orange;
    animation: jump 0.6s 0.9s ease-in infinite
  }
  
  
  @keyframes jump{
    0%{
      transform: translate3D(0,0,0);
      opacity: 0;
    }
      50%{
      transform: translate3D(0,-15px,0);
        opacity: 0.5;
    }
      100%{
      transform: translate3D(0,0,0);
        opacity: 1;
    }
  }

  .modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    &:target {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
    & > div {
      width: 580px;
      height: 450px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 2em;
      border: 1px solid #2F2F2F;
      backdrop-filter: blur(13px);
      background: url(../assets/modal_bg.png) no-repeat fixed center, #0A070F;
      box-sizing: border-box;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
    h2 {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    .welcome {
        margin-top: 8px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    label {
        text-align: left;
        color: #fff;
        font-size: 12px;
        margin-left:15px;
        margin-bottom: -6px;
    }
    span {
        margin-bottom: 20px;
    }

}
.modal-container{
    display: flex;
    flex-direction: row;
}
.login-modal-box {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0 solid;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
  }

  .btn-login {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    gap: 10px;
    background: #D33E74;
    border-radius: 82px;
    margin-top: 8px;
    color: #fff;
    width: 100%;
    
}
  .modal-close {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
  }
  .modal-close-mobile {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: none;
  }
  .modal-window {
    & > div {
        border-radius: 63px;
    }
  }
  .modal-logo {
    text-align: center;
    margin-top: -10px;
  }
  .modal-logo > img {
    width: 100px;
    
}
h2 {
   
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 10px;
    line-height: 42px;
    text-align: center;
    color: #FFFFFF;
    line-height: 190%;
    margin-top: 0px;

}

@media screen and (max-width: 768px) {

.modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    &:target {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
    & > div {
      width: 90%;
      height: 490px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 2em;
      border: 1px solid #2F2F2F;
      backdrop-filter: blur(13px);
      box-sizing: border-box;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
  }
.modal-container{
    display: flex;
    flex-direction: row;
}
  .modal-close {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: none;
  }
  .modal-close-mobile {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: block;
  }
  .modal-window {
    & > div {
        border-radius: 63px;
    }
  }
  .modal-logo > img {
    width: 90px;
    text-align: center;
}
h2 {
   
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 17px;
    line-height: 42px;
    text-align: center;
    color: #FFFFFF;
    line-height: 190%;
    margin-top: 20px;

}

.terms {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 19px;
    text-align: center;
    color: #FFFFFF;

    span {
        color: #D33E74;
    }
}

}
.modal-mask {
    // position: fixed;
     z-index: 9998;
     top: 0;
     left: 0;
     //width: 100%;
     height: 100%;
     background: rgba(0, 0, 0, .5) !important;
     display: table;
     transition: opacity .3s ease;
     & > div {
         //width: 100%;
         height: 120px;
         position: absolute;
         top: 50%;
         left: 50%;
         transform: translate(-50%, -50%);
         //padding: 2em;
         border: 1px solid #2F2F2F;
         //backdrop-filter: blur(13px);
         background: #19181B;
         border-radius: 20px;
         box-sizing: border-box;
       }
       .profile-view2{
         box-sizing: border-box;
         border-radius: 20px;
         //position:relative;
         width: 100%;
         height: 100%;
         background: #111112;
         .profile-photo2{
             width: 100%;
             height: auto;
             background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
         }
     }


     .profile-interest2{
         
         h3 {
             width: auto;
             height: 26px;
             font-family: 'DM Sans';
             font-style: normal;
             font-weight: 700;
             font-size: 20px;
             line-height: 26px;
             text-align: left;
             color: #FFFFFF;
             margin:20px;
         }
         .interests2{
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 2px 8px;
             width: auto;
             height: 29px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 50px;
             color: #767475;
             font-size: 10px;
             margin: 4px;
 
         }
 
         .interests-info2 {
             display: flex;
             flex-direction: row;
             //padding: 0rem 3rem 5rem 1rem;
         }
     }
     .profile-relationship-goal2 {
         margin-top: -150px !important;
         h3 {
             width: auto;
             height: 26px;
             font-family: 'DM Sans';
             font-style: normal;
             font-weight: 700;
             font-size: 20px;
             line-height: 26px;
             text-align: left;
             color: #FFFFFF;
             margin:20px;
         }
         .relationship-goal2 {
             display: flex;
             flex-direction: row;
             padding: 2px;
             width: 70%;
             height: auto;
             background: rgba(255, 214, 0, 0.1);
             border-radius: 61px;
             color: #FFD600;
             font-size: 10px;
             margin: 20px;
             text-align: left;
         }
 
     }
     .btn-unmatch-report2 {
         display: flex;
         flex-direction: row;
         align-items: center;
         .btn-unmatch2 {
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #D33E74;
             margin: 20px;
             cursor: pointer;
         }
         .btn-unmatch3 {
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #b1acae;
             margin: 20px;
             cursor: pointer;
         }
         .btn-report2 {
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #2D2D2D;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #767475;
             margin-right: 10px;
             cursor: pointer;
         }
     }
}
.content-fluid {
    background: transparent;
}
.container-fluid {
    margin-top: 80px !important;
    background: #fff;
    border-radius: 10px;
    padding: 10px 10px 10px 10px;
}
.profile-container{
    display: flex;
    flex-direction: row;
}
.large-profile-pic {
  width: 140px;
  height: 140px;
  border-radius: 50%;
}

 .profile-image {
    display: flex;
    flex-direction: row;
    width: 100%;

    .img-profile {
        width: 60%;
        height: 60%;
        margin:2px;
        border-radius: 100px;
    }

    .profile-info {
        display: flex;
        flex-direction: column;
        justify-content: left;

        h3 {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: bold;
            font-size: 25px;
            text-align: left;
            color: #FFFFFF;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 15px;
            text-align: left;
            color: #FFFFFF;
        }        
    }
    .bio-trials{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        color: #FFFFFF;
        font-family: 'Raleway';
        font-weight: 650;
    
        .btn-trial{
            background: #FFD600;
            border: solid 0;
            color: #000;
            border-radius: 10px;
            font-size: 11px;
            padding: 0.4rem;
        }
    }
    .bio-buttons{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        font-family: 'Raleway';
        font-weight: 650;

        .btn-tour{
            background: #D33E74;
            color: #000;
            border: solid 0;
            border-radius: 10px;
            font-size: 11px;
            padding: 0.4rem;
        }
        .btn-boost{
            background: green;
            border: solid 0;
            border-radius: 10px;
            font-size: 11px;
            padding: 0.4rem;
            color: #ddd;
        }
        .btn-activate{
            background: transparent;
            border: solid 0;
            font-size: 11px;
            a{
                color: green;
                text-decoration: none;
            }
        }

        .btn-chat {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px 8px;
        width: 100px;
        height: 30px;
        background: #007BFF;
        border: 0px solid;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
    }
        
    }
    .select-profile{
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 68.1%, rgba(0, 0, 0, 0.5) 78.43%), #2F2F2F;
        border: 3px solid #D33E74;
        border-radius: 50%;
        width: 145px;
        height: 145px;
        display: block;
        margin-top: 15px;
        margin-bottom: 25px;
    }
 }
 .profile-picture{
    display: flex;
    flex-direction: row;
    justify-content: left;
    margin-right: 10px;
 }
.profile-edit-button{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

    .btn-edit {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px 18px;
        width: 120px;
        height: 40px;
        background: #D33E74;
        border: 0.5px solid #D33E74;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
    }
}

.photo {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 28px;
    text-align: left;
    color: #FFFFFF;
    margin-left: -45px;
    margin-top: 10px;

}

 .edit-profile-top {
    width: 100%;
 }
 .user-interests{
    display: flex;
    flex-wrap: wrap;
    gap: 10px; /* spacing between buttons */
 }

 .btn-chips {
  padding: 8px 16px;
  border: none;
  background-color: #eee;
  border-radius: 20px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  transition: background-color 0.3s;
}

.btn-chips:hover {
  background-color: #ddd;
}

 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
 }
 .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;
        //background: #D9D9D9;
    }
 .profile-content{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .column1{
    width: 400px;
    margin: 10px;
 }
 .button-container{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-textx {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 350px;
    height: 45px;
    background: #2D2D2D;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }

 .input-text-state {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 350px;
    height: 45px;
    background: #2D2D2D;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .birthday{
    display: flex;
    flex-direction: row;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 114px;
    height: 55px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    color: #767475;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 400px;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
    margin-bottom: 40px;
}

.btn-chips {
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    padding: 4px 10px;
    width: auto;
    height: 25px;
    margin: 3px;
    margin-bottom: 20px;
    background: #0A070F;
    border: 0.5px solid #D33E74;
    border-radius: 50px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 16px;
    text-align: center;
    color: #D33E74;
}      

@media screen and (max-width: 700px) {
    .container{
        margin-top: 100px;
        //padding: 0px 0px 0px 0px !important;
    }
    .profile-container{
        display: flex;
        flex-direction: column;
 
    }
    .profile-image {
        display: flex;
        flex-direction: column;
        align-items: center;

        .img-profile {
            width: 30%;
            height: 30%;

        }
        .profile-info {
            padding: 0 0 0 0px;
            h3 {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: bold;
                font-size: 25px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
            }
            p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
            }
          
        }
        .select-profile{
            width: 145px;
            height: 145px;
        }
     }
    .profile-edit-button{
        margin-top: 10px;
        margin-bottom: 20px;
    
        .btn-edit {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px 18px;
            width: 100px;
            height: 35px;
            background: #D33E74;
            border: 0.5px solid #D33E74;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
    }
    .mobile-line{
        color: #767475;
        width: 100%;
    }
    .photo {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 18px;
        line-height: 28px;
        text-align: left;
        color: #FFFFFF;
        margin-left: 55px;
        margin-top: 50px;
    }
    .bio-trials{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        color: #FFFFFF;
        font-family: 'Raleway';
        font-size: 12px;
        button{
            box-sizing: border-box;
            width: auto;
            height: 20px;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 600;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
        .btn-trial{
            background: #FFD600 !important;
            width: auto !important;
            height: auto !important;
            font-size: 10px !important;
            padding: 4px !important;
            border-radius: 10px !important;
            border: solid 0;
            color: #000;
        }
    }
    .bio-buttons{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .btn-tour{
            background: #D33E74;
            color: #000;
            border: solid 0;
            border-radius: 10px;
            font-size: 10px;
            height: auto;
        }
        .btn-boost{
            background: #000 !important;
            border: solid 0;
            width: 30% !important;
            height: auto !important;
            font-size: 10px !important;
            border-radius: 10px !important;
        }
        .btn-activate{
            background: transparent;
            border: solid 0;
            text-decoration: none;
            color: green;
            width: 40% !important;
            height: auto !important;
            font-size: 10px !important;

        }

        .btn-chat {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px 8px;
            width: 80px;
            height: 35px;
            background: #007BFF;
            border: 0px solid;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
        
    }
 .edit-profile-top {
  margin-left: 0px;
 }

 .profile-content{
    display: flex;
    flex-direction: column;
 }
 .column1{
    width: 100%;
    margin: 0px;
 }
 .user-interests{
   
 }
 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;

    .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;

    }
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 35px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
 }
 .birthday{
    display: flex;
    flex-direction: column;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    color: #fff;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
   
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 100%;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
}

}

</style>
